import React, { createContext, useContext, useRef } from 'react';
import { getResultPropKey } from '../utils/getResultPropKey';
const contexts = {};
const getContext = key => {
  if (!contexts[key]) {
    contexts[key] = /*#__PURE__*/createContext(undefined);
  }
  return contexts[key];
};
export function withFunctionObservationResult(Component, options) {
  return props => {
    const resultPropKey = getResultPropKey(options == null ? void 0 : options.resultPropName);
    const Context = getContext(resultPropKey);
    const ref = useRef();
    const value = {
      ref,
      ...props[resultPropKey]
    };
    const otherProps = {
      ...props
    };

    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete otherProps[resultPropKey];
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: value
    }, /*#__PURE__*/React.createElement(Component, otherProps));
  };
}
export const useObservationResultData = options => {
  const resultPropKey = getResultPropKey(options == null ? void 0 : options.resultPropName);
  return useContext(getContext(resultPropKey));
};
//# sourceMappingURL=withFunctionObservationResult.js.map